import React, { useRef } from "react";
import logo from "../../media/images/logo.jpeg";
import { Link } from "react-router-dom";

const SmallNavbar = () => {

    const navRef = useRef();

    const showNavbar = () => {
      navRef.current.classList.toggle("small-nav-responsive");
    };
    
  return (
    <div>
      <div className="small-nav">
      <div className="small-nav-top">Get Upto 15% Off On All Services <span>(Limited Period Offer*)</span></div>
        <div className="small-nav-main">
          <div className="small-nav-head">
          
                    {/* L  <img src={logo} alt="" /> */}
          
            <div className="sm-bhumu-company-logo-text">
               <div>Repair</div>
              <div>Buddy</div>


               </div>

            <div>
            {/* <Link
              to="tel:+919220407009"
              target="blank"
              className="footer-heading-3"
            >
              <i class="fa-solid fa-phone-volume"></i> +91 9220-407-009
            </Link> */}

            <i class="fa-solid fa-bars"  onClick={showNavbar}></i>
            </div>
          </div>
          <div className="small-nav-menu" ref={navRef}>
          <div>
            <i class="fa-solid fa-xmark"  onClick={showNavbar}></i>
            <div className="small-nav-list">
              
              <a onClick={showNavbar} href="#price-list">PRICE LIST </a>
              <a onClick={showNavbar} href="#about-us">ABOUT US</a>
              <a onClick={showNavbar} href="#why-us">WHY US</a>
              <a onClick={showNavbar} href="#testimonial">TESTIMONIALS</a>
              <a onClick={showNavbar} href="#faqs">FAQS</a>

            </div>
            <div className="small-nav-contact">
              <div className="small-nav-contact-heading">Contact Info</div>

              {/* <div className="small-nav-contact-list">
                <i class="fa-solid fa-location-dot"></i>
                Sector-18, Noida
              </div> */}

              <div className="small-nav-contact-list">
                <i class="fa-solid fa-envelope-open-text"></i>
                repairbuddyonline@gmail.com
              </div>

              {/* <div className="small-nav-contact-list">
                <i class="fa-solid fa-phone-volume"></i>
                +91 9220-407-009
              </div> */}
            </div>

            <div className="small-nav-social">
              <a to="">
                <i class="fa-brands fa-facebook-f"></i>
              </a>
              <a to="">
                <i class="fa-brands fa-twitter"></i>
              </a>
              <a to="">
                <i class="fa-brands fa-instagram"></i>
              </a>
              <a to="">
                <i class="fa-brands fa-google"></i>
              </a>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallNavbar;
